// src/components/ListView/Menu.js

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { IconButton, Menu, MenuItem, withStyles } from '@material-ui/core'
import { MoreHoriz, MoreVert, Delete, Edit } from '@material-ui/icons'
import { ContentDuplicate, Pin, PinOff } from 'mdi-material-ui'
import { toggleDeleteDialog } from 'actions/view'
import language from 'utils/vast-languagepack'
import { isPinnedSelector } from 'selectors/userpin'
import { create, deleteEntity } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
import { forceListUpdate } from 'actions/view'

export default connect(
  (state, { entityType, entitySubtype, entityID }) => {
    const entityTypeToEndpointMap = {
      template: `${entitySubtype}/template`,
      form: 'customform',
      group: 'contactgroup',
    }

    const secondary_id = entityTypeToEndpointMap[entityType] || entityType

    const isPinned = isPinnedSelector(state, secondary_id, entityID)

    if (isPinned) {
      return {
        isPinned,
        userpin: state.userpins?.[secondary_id]?.[entityID],
      }
    }

    return {
      isPinned,
    }
  },
  (dispatch, { deleteFn }) =>
    bindActionCreators(
      { toggleDeleteDialog, create, deleteEntity, forceListUpdate },
      dispatch,
    ),
)(
  withStyles(theme => ({
    expandPanelDetailsIconSecondary: {
      position: 'absolute',
      right: '8px',
      top: '67%',
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
      fill: theme.palette.text.secondary,
    },
    root: {
      [theme.breakpoints.down('sm')]: {
        padding: 4,
      },
    },
  }))(
    class SimpleMenu extends Component {
      state = {
        anchorEl: null,
      }

      handleClick = event => {
        this.setState({ anchorEl: event.currentTarget })
      }

      handleClose = () => {
        this.setState({ anchorEl: null })
      }

      handleDeleteClick = () => {
        this.setState({ anchorEl: null })
        this.props.toggleDeleteDialog({
          id: this.props.entityID,
          name: this.props.entityName,
          entityType: this.props.entityType,
          entitySubtype: this.props.entitySubtype,
        })
      }

      render() {
        const { anchorEl } = this.state
        const {
          classes,
          horiz,
          vert,
          entityID,
          addOrEditPush,
          expanded,
          idx,
          entitySubtype,
          entityType,
          readAndCreateTemplate,
          campaignMenuItemContent,
          updateStatus,
        } = this.props

        const entityTypeToEndpointMap = {
          template: `${entitySubtype}/template`,
          form: 'customform',
          group: 'contactgroup',
        }

        const secondary_id = entityTypeToEndpointMap[entityType] || entityType

        return (
          <div>
            <IconButton
              aria-owns={anchorEl ? `deleteMenu${entityID}` : undefined}
              aria-haspopup="true"
              onClick={this.handleClick}
              style={
                horiz
                  ? {
                      display: expanded === idx ? 'inline-flex' : 'none',
                    }
                  : vert
                  ? {
                      position: 'absolute',
                      right: 0,
                      top: '50%',
                      transform: 'translate(0, -50%)',
                    }
                  : null
              }
              className={horiz ? classes.expandPanelDetailsIconSecondary : null}
              classes={{ root: classes.root }}
            >
              {horiz ? <MoreHoriz /> : null}
              {vert ? <MoreVert /> : null}
            </IconButton>
            <Menu
              id={`deleteMenu${entityID}`}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              {entityType === 'campaign' && (
                <MenuItem
                  onClick={() => {
                    updateStatus()
                    this.handleClose()
                  }}
                >
                  {campaignMenuItemContent}
                </MenuItem>
              )}
              <MenuItem onClick={() => addOrEditPush(entityID, entitySubtype)}>
                <Edit className={classes.leftIcon} />
                {language.task.add.edit}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  if (this.props.isPinned) {
                    if (this.props.userpin?.id) {
                      this.props
                        .deleteEntity(
                          this.props.userpin.id,
                          'userpin',
                          `${DATA_API_URL}/userpin/${this.props.userpin.id}`,
                          'none',
                          null,
                          this.props.userpin,
                        )
                        .then(() => this.props.forceListUpdate())
                    } else {
                      console.log('error: no userpin?.id found')
                    }
                  } else {
                    this.props
                      .create({
                        entityType: 'userpin',
                        entity: {
                          pinned_entity_id: entityID,
                          secondary_id,
                        },
                        url: `${DATA_API_URL}/userpin`,
                        hasSchema: false,
                        snackbarMessage: 'none',
                      })
                      .then(() => this.props.forceListUpdate())
                  }
                  this.handleClose()
                }}
              >
                {this.props.isPinned ? (
                  <>
                    <PinOff className={classes.leftIcon} />
                    Unpin
                  </>
                ) : (
                  <>
                    <Pin className={classes.leftIcon} />
                    Pin
                  </>
                )}
              </MenuItem>
              {entityType === 'template' && (
                <MenuItem
                  onClick={() => {
                    readAndCreateTemplate()
                    this.handleClose()
                  }}
                >
                  <ContentDuplicate className={classes.leftIcon} />
                  Duplicate
                </MenuItem>
              )}
              <MenuItem onClick={this.handleDeleteClick}>
                <Delete className={classes.leftIcon} />
                {language.task.add.delete}
              </MenuItem>
            </Menu>
          </div>
        )
      }
    },
  ),
)
